import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function MailIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="19.284" height="14.531" viewBox="0 0 19.284 14.531" {...props}>
      <g id="Group_6223" data-name="Group 6223" transform="translate(1 1)">
        <g id="Group_5977" data-name="Group 5977">
          <path 
            id="Path_6494" 
            data-name="Path 6494" 
            d="M833.939,1034.2a138.053,138.053,0,0,1-14.141,0,1.5,1.5,0,0,1-1.367-1.313,55.732,55.732,0,0,1,0-9.543,1.5,1.5,0,0,1,1.367-1.313,137.983,137.983,0,0,1,14.141,0,1.5,1.5,0,0,1,1.367,1.313,55.707,55.707,0,0,1,0,9.543A1.5,1.5,0,0,1,833.939,1034.2Z" 
            transform="translate(-818.227 -1021.849)" 
            fill="none" 
            stroke="currentColor" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2"
          />
          <path 
            id="Path_6495" 
            data-name="Path 6495" 
            d="M819.056,1022.758c2.426,1.875,5.144,3.97,7.85,6.063,2.822-2.092,5.662-4.193,8.2-6.063" 
            transform="translate(-818.439 -1022.082)" 
            fill="none" 
            stroke="currentColor"
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default MailIcon;


// WEBPACK FOOTER //
// ./src/components/icons/MailIcon.jsx